export enum ConstructionSequenceId {
  Initial = 1,
  Return = 2
}

export enum PlannedReservePitBackfillTypeId {
  DeepBurial = 1
}

export enum DrillPadBaseTypeId {
  Limestone = 1
}

export enum TankBatteryBaseTypeId {
  Limestone = 1
}

export enum ConstructionFenceTypeId {
  CattleGuard = 1,
  Gates = 2
}

export enum LineRerouteId {
  ESP = 1,
  Pipeline = 2,
  Poly = 3,
  Power_Overhead = 4,
  Power_Buried = 5,
  None = 6,
  NoBurialOrReroute = 7
}

export enum AuxPadBaseTypeId {
  Limestone = 1
}

export enum SoundMaterialTypeId {
  Metal = 1,
  Other = 2,
  MassLoadedVinyl = 3
}

export enum CulvertsTypeId {
  Corrugated_Metal_Pipe = 1
}